import { useContext } from "react";
import { AppContext } from "../Context/Context";

const RAZON_SOCIAL_FCA = {
    mayusculas: "FCA S.A. DE AHORRO PARA FINES DETERMINADOS",
    titulo: "FCA S.A. de Ahorro para Fines Determinados",
    minusculas: "FCA S.A. de ahorro para fines determinados",
    sigla: "FCA",
};

const RAZON_SOCIAL_STELLANTIS = {
    mayusculas: "STELLANTIS S.A. DE AHORRO PARA FINES DETERMINADOS",
    titulo: "STELLANTIS S.A. DE AHORRO PARA FINES DETERMINADOS",
    minusculas: "STELLANTIS S.A. DE AHORRO PARA FINES DETERMINADOS",
    sigla: "STELLANTIS",
};

// Devuelve la razon social a mostrar en los textos legales segun el parametro
// razonSocialStellantisEnabled del admin. Cada variante es el mismo nombre con
// la tipografia que usa cada texto (mayusculas, titulo o minusculas).
export const useRazonSocial = () => {
    const [state] = useContext(AppContext);

    return state.razonSocialStellantisEnabled ? RAZON_SOCIAL_STELLANTIS : RAZON_SOCIAL_FCA;
};
